import { render, staticRenderFns } from "./SaitenEditTab.vue?vue&type=template&id=3b766f9e&scoped=true&"
import script from "./SaitenEditTab.vue?vue&type=script&lang=ts&"
export * from "./SaitenEditTab.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenEditTab.vue?vue&type=style&index=0&id=3b766f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b766f9e",
  null
  
)

export default component.exports